module.exports = __webpack_public_path__ + "media/images/icons/icons_large/54_bulletbow-4adfba89c581d17e7f919a7798e8652a.png";